import React from 'react';
import { InviteEmployeeForm } from '@sales-portal/domain/accounts/screens/employee-list/containers/employee-invite-drawer/components/invite-employee-form';
import { useInviteEmployeeForm } from '@sales-portal/domain/accounts/screens/employee-list/containers/employee-invite-drawer/blocs/hooks/use-invite-employee-form';
import { useInviteRestaurantEmployeeMutator } from '@sales-portal/domain/accounts/screens/employee-list/containers/employee-invite-drawer/blocs/mutators/use-invite-restaurant-employee-mutator';

interface EmployeeInvitePanelContentProps {
  onClose: () => void;
  restaurantUUID: string;
  supplierUUID: string;
}

export const EmployeeInvitePanelContent: React.FC<
  EmployeeInvitePanelContentProps
> = ({ onClose, restaurantUUID, supplierUUID }) => {
  const { invite, inviting } = useInviteRestaurantEmployeeMutator();
  const { canSubmit, form, setFormField } = useInviteEmployeeForm();

  const handleSubmit = async (): Promise<void> => {
    if (!canSubmit || inviting) {
      return;
    }
    const succeeded = await invite({
      communicationEmail: form.communicationEmail,
      countryCode: form.countryCode,
      isAdmin: form.isAdmin,
      loginEmail: form.loginEmail,
      name: form.name,
      phoneNumber: form.phoneNumber,
      restaurantUUID,
      supplierUUID,
    });
    if (succeeded) {
      onClose();
    }
  };

  return (
    <InviteEmployeeForm
      canSubmit={canSubmit}
      form={form}
      inviting={inviting}
      onSubmit={handleSubmit}
      setFormField={setFormField}
    />
  );
};
